
export default {
  computed: {
    spinnerColor() {
      return this.color || this.$parent.color;
    },

    spinnerSize() {
      return (this.size || this.$parent.size) + 'px';
    }
  },

  props: {
    size: Number,
    color: String
  }
};



// WEBPACK FOOTER //
// ./packages/spinner/src/spinner/common.vue